// extracted by mini-css-extract-plugin
export default {"page":"LeftMenuLayout_page__hZdDr","content":"LeftMenuLayout_content__2u1fB"};